import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-funding-options',
    templateUrl: './funding-options.component.html',
    styleUrls: ['./funding-options.component.scss'],
    standalone: false
})
export class FundingOptionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
